"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clickStreamEventSchema = require("./clickStreamEventSchema");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  newLanePayload: _propTypes.default.shape({
    envelope: _propTypes.default.shape({
      event_template_id: _propTypes.default.string,
      event_template_version_id: _propTypes.default.string,
      event_type_id: _propTypes.default.string,
      event_type_version_id: _propTypes.default.string,
      event_client_start_dtm: _propTypes.default.string
    }),
    clickstream_trigger: _propTypes.default.shape({
      trigger_location_nm: _propTypes.default.oneOf(['home_details', 'search_results', 'home', 'owner_dashboard', 'how_much_is_my_home_worth']),
      trigger_type_nm: _propTypes.default.oneOf(Object.values(_clickStreamEventSchema.CLICKSTREAM_EVENT_TYPE)),
      trigger_object_nm: _propTypes.default.oneOf(['property_details_component|neighborhood', 'property_details_component|summary', 'property_details_component|home_value', 'property_details_component|summary', 'property_details_component|overview', 'search_results', 'home|rtb1', 'home|rtb2', 'home|rtb3', 'no_trigger_object']),
      trigger_source_nm: _propTypes.default.oneOf(['onsite_message_component|top', 'onsite_message_component|bottom', 'onsite_message_component|rtb1', 'onsite_message_component|rtb2', 'onsite_message_component|rtb3', 'onsite_message_component|hero_image', 'button_to_interact_with_bottom_onsite_message', 'button_to_interact_with_top_onsite_message', 'button_to_interact_with_rtb1_onsite_message', 'button_to_interact_with_rtb2_onsite_message', 'button_to_interact_with_rtb3_onsite_message']),
      input_selector_nm: _propTypes.default.oneOf(['mouse', 'keyboard', 'touch', 'other'])
    }),
    semanticBlock: _propTypes.default.shape({
      semantic_event_nm: _propTypes.default.oneOf(['omp_placement_view', 'omp_placement_interaction']),
      topic_tag_txt: _propTypes.default.arrayOf('omp')
    }),
    omp: _propTypes.default.shape({
      event_type_nm: _propTypes.default.oneOf(Object.values(_clickStreamEventSchema.CLICKSTREAM_EVENT_TYPE)),
      skip_display_reason_txt: _propTypes.default.string,
      should_display_ind: _propTypes.default.bool,
      global_handout_ind: _propTypes.default.bool,
      placement_holdout_ind: _propTypes.default.bool,
      placement_nm: _propTypes.default.string,
      test_phase_nm: _propTypes.default.oneOf(['baseline', 'targetSelection', 'portfolioIntegration', 'unknown']),
      bucket_nm: _propTypes.default.oneOf(['CONTROL', 'BASELINE_CTRL', 'BASELINE_TREATMENT', 'TARGET_SELECTION_CTRL', 'TARGET_SELECTION_TREATMENT', 'PORTFOLIO_INTEGRATION_CTRL', 'PORTFOLIO_INTEGRATION_TREATMENT']),
      placement_id: _propTypes.default.number,
      throttle_pass_ind: _propTypes.default.bool,
      last_modified_dtm: _propTypes.default.string,
      event_id: _propTypes.default.string,
      decision_context_guid: _propTypes.default.string,
      decision_context_encoded_zuid: _propTypes.default.string,
      selected_treatment_id: _propTypes.default.number,
      selected_treatment_nm: _propTypes.default.string,
      selected_treatment_status_cd: _propTypes.default.string,
      selected_treatment_last_modified_dtm: _propTypes.default.string,
      selected_treatment_lob_nm: _propTypes.default.string,
      selected_treatment_experiment_family_nm: _propTypes.default.string,
      selected_treatment_experiment_iteration_txt: _propTypes.default.string,
      selected_treatment_variation_nm: _propTypes.default.string,
      qualified_treatment_portfolio_nm: _propTypes.default.arrayOf(_propTypes.default.string),
      qualified_treatment_portfolio_test_nm: _propTypes.default.arrayOf(_propTypes.default.string),
      qualified_treatment_target_selection_nm: _propTypes.default.arrayOf(_propTypes.default.string),
      qualified_treatment_baseline_evaluation_nm: _propTypes.default.arrayOf(_propTypes.default.string)
    }),
    // Validate below props in MTT-2963
    property_info: _propTypes.default.object,
    search_filter: _propTypes.default.object,
    search_map: _propTypes.default.object,
    search_result: _propTypes.default.object
  })
};
exports.default = _default;